<template lang="pug">
  .header-stat
    btn-preloader.header-stat__pre-loader(v-if="requestPending")
    .header-stat-bar(v-if="!requestPending && statistics.trust && sumCountOfVote !== 0")
      .header-stat-bar__item(
        :style="{ 'width': `${getItemBarWidth(statistics.trust[0]['positive'])}%`, 'background': '#36a134', 'color': '#36a134' }"
      )
        .header-stat-bar__title(
          v-if="statistics"
        ) {{ `${getItemBarWidth(statistics.trust[0]['positive'])}%` }}
      .header-stat-bar__item(
        :style="{ 'width': `${getItemBarWidth(statistics.trust[0]['netural'])}%`, 'background': '#888', 'color': '#888' }"
      )
        .header-stat-bar__title(
          v-if="statistics"
        ) {{ `${getItemBarWidth(statistics.trust[0]['netural'])}%` }}
      .header-stat-bar__item(
        :style="{ 'width': `${getItemBarWidth(statistics.trust[0]['negative'])}%`, 'background': '#f92626', 'color': '#f92626' }"
      )
        .header-stat-bar__title(
          v-if="statistics"
        ) {{ `${getItemBarWidth(statistics.trust[0]['negative'])}%` }}
    .header-stat-help(v-else-if="sumCountOfVote === 0") Мало данных за выбранный период
    span.header-stat-bar__range(@click="selectRange = !selectRange")
      span(v-html="currentRange")
      .header-stat-bar__menu(v-if="selectRange")
        .header-stat-bar__menu-item(
          @click="currentRange = ' за день'"
        ) За день
        .header-stat-bar__menu-item(
          @click="currentRange = ' за месяц'"
        ) За месяц
    span.statistic-button(
      @click="openStatistic($event)"
    ) Статистика
</template>

<script>
import router from '@/router';
import { getStatisticApi, getThreadsApi, getStatisticOverAllApi } from "@/api/posts";
import { SET_POSTS_COUNT } from "@/store/actions/threadInfo";
import { SET_COMMENTS_COUNT } from "@/store/actions/threadInfo";
import BtnPreloader from "@/components/preLoaders/btnPreloader.vue";

export default {
  name: 'headerStat',
  components: { BtnPreloader },
  data() {
    return {
      statistics: '',
      selectRange: false,
      currentRange: ' за день',
      requestPending: false,
    };
  },
  mounted() {
    this.getStatistic();
  },
  methods: {
    openStatistic(event) {
      this.$root.$emit('toggleModal', { target: event.target });
    },
    getOverAllStatistic() {
      this.requestPending = true;
      getThreadsApi()
        .then((resp) => {
          if (resp.status === 403) {
            localStorage.removeItem('status');
            router.push('/login');
          }
          getStatisticOverAllApi({ thread_id: process.env.VUE_APP_THREAD_ID, days: 30 })
            .then((resp) => {
              this.statistics = resp.data;

              if (!this.statistics) {
                localStorage.removeItem('status');
                router.push('/login');
              }
              delete this.statistics.trust[0]['thread_id'];
              this.$store.dispatch(SET_POSTS_COUNT, this.statistics['total']);
              this.$store.dispatch(SET_COMMENTS_COUNT, this.statistics.poststats['comments']);
              this.requestPending = false;
            })
            .catch((err) => {
              if (err.response && err.response.status === 403) {
                localStorage.removeItem('status');
                router.push('/login');
              }

              this.requestPending = false;
              return err;
            });
        })
        .catch((err) => {
          if (err.response && err.response.status === 403) {
            localStorage.removeItem('status');
            router.push('/login');
          }
          this.requestPending = false;
          return err;
        });
    },
    getStatistic() {
      this.requestPending = true;
      getThreadsApi()
        .then((resp) => {
          if (resp.status === 403) {
            localStorage.removeItem('status');
            router.push('/login');
          }
          getStatisticApi({ thread_id: process.env.VUE_APP_THREAD_ID})
            .then((resp) => {
              this.statistics = resp.data;

              if (!this.statistics) {
                localStorage.removeItem('status');
                router.push('/login');
              }

              delete this.statistics.trust[0]['thread_id'];
              this.$store.dispatch(SET_POSTS_COUNT, this.statistics['total']);
              this.$store.dispatch(SET_COMMENTS_COUNT, this.statistics.poststats['comments']);
              this.requestPending = false;
            })
            .catch((err) => {
              if (err.response && err.response.status === 403) {
                localStorage.removeItem('status');
                router.push('/login');
              }

              this.requestPending = false;
              return err;
            });
        })
        .catch((err) => {
          if (err.response && err.response.status === 403) {
            localStorage.removeItem('status');
            router.push('/login');
          }

          this.requestPending = false;
          return err;
        });
    },
    getItemBarWidth(itemValue) {
      return Math.round(100 * itemValue / this.sumCountOfVote);
    }
  },
  computed: {
    sumCountOfVote() {
      if (!this.statistics) {
        return 0;
      }
      return this.statistics.trust[0]['negative'] + this.statistics.trust[0]['netural'] +
        this.statistics.trust[0]['positive']
    }
  },
  filters: {
    getItemName(value) {
      if (value === 'negative') return '';
      if (value === 'netural') return '';
      if (value === 'positive') return '';
      if (value === 'total') return 'Всего:';
    },
    getItemIcon(value) {
      if (value === 'negative') return '/dislike-thumb.svg';
      if (value === 'netural') return '/neutral-thumb.svg';
      if (value === 'positive') return '/like-thumb.svg';
    }
  },
  watch: {
    currentRange(curVal) {
      if (curVal === ' за день') {
        this.getStatistic();
      } else {
        this.getOverAllStatistic();
      }
    },
  }
};
</script>

<style lang="stylus">
.sk-wave.header-stat__pre-loader
  height 1em
  margin 0 0 0 1em
  width auto
  .sk-rect
    background-color #fff
    height 1em
.header-stat
  width 100%
  display flex
  align-items center
  justify-content center
  color #fff
  padding .5em 0
  margin-top 1em
  @media screen and (max-width 1000px) and (min-width 600px)
    order -1
    width auto
    margin 0 auto
.stat-item
  display flex
  align-items center
  margin 0 .5em
  &__icon
    width 2em
    height auto
  &__value
    margin-left .3em
    font-size 1.4em
.header-stat-bar
  width 25em
  height 1em
  margin-left 1em
  display flex
  div:last-child
    border-top-right-radius .5em
    border-bottom-right-radius .5em
  div:first-child
    border-top-left-radius .5em
    border-bottom-left-radius .5em
  &__ttl
    flex-shrink 1
  &__range
    text-decoration underline
    position relative
    cursor pointer
    margin-left 1em
  &__menu
    position absolute
    left 50%
    top 120%
    z-index 10
    background #fff
    border 1px solid #3a3a3a
    border-radius 4px
    transform translate(-50%, 0)
    overflow hidden
    @media screen and (max-width 600px)
      left auto
      right 0
      transform translate(0,0)
    &-item
      color #000
      white-space nowrap
      padding 0.8em 1.2em
      cursor pointer
      &:hover
        background #edeef0
  &__item
    transition .5s linear
    width 0
    position relative
    &:hover ^[0]__title
      opacity 1
      visibility visible
  &__title
    position absolute
    left 50%
    bottom 110%
    transform translate(-50%, 0)
    white-space nowrap
    z-index 10
    border-radius: 4px;
    color inherit

.statistic-button {
  display inline-block;
  margin-left 10px;
  cursor pointer;
  text-decoration: underline;
}
</style>
